import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CostAdjustmentStateEnums } from 'src/app/enum/cost-adjustment-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { FormatModel } from 'src/app/models/formats/format.model';
import { CostAdjustmentModel } from 'src/app/models/inventory/cost-adjustment.model';
import { CostAdjustmentPrintModel } from 'src/app/models/print/inventory/cost-adjustment-print-model';
import { ProviderService } from 'src/app/services/archive/provider.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { CostAdjustmentService } from 'src/app/services/inventory/cost-adjustment.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-cost-adjustment',
  templateUrl: './register-cost-adjustment.component.html',
  styleUrls: ['./register-cost-adjustment.component.scss'],
  standalone: false
})
export class RegisterCostAdjustmentComponent implements OnInit {

  branchId: number = 0;
  companyId: number = 0;
  costAdjustmentContract: CostAdjustmentModel = new CostAdjustmentModel();
  costAdjustmentId: number = 0;
  costAdjustmentPrintModel: CostAdjustmentPrintModel = new CostAdjustmentPrintModel();
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  formCostAdjustment: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  hasAdjustedUnitCostInZero: number = 0
  icon: string = "pi pi-lock-open";
  inventoryId: number = 0;
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listInventories: any[] = [];
  listInventoryEntries: any[] = [];
  listObservers: Subscription[] = [];
  listProviders: any[] = [];
  nameWindow: string = 'Captura Ajuste Costos';
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  providerId: number = 0;
  quantityDetails: number = 0;
  severityState: string = "danger";
  stateText: string = 'Abierta';
  titleState: string = '';
  url: string = 'cost-adjustment';

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private costAdjustmentService: CostAdjustmentService,
    private location: Location,
    private providerService: ProviderService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(new CostAdjustmentModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.costAdjustmentId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    await this.getAllLists();
    this.resetContract();
  }

  async changeInventory(inventoryId: number) {
    this.inventoryId = inventoryId;
    this.resetContract();
  }

  async changeinventoryEntry(currentInventoryEntryId: number) {
    const previousInventoryEntryId = this.costAdjustmentContract.inventoryEntryId;
    if (previousInventoryEntryId != currentInventoryEntryId && this.quantityDetails > 0) {
      setTimeout(() => this.formCostAdjustment.controls['inventoryEntryId'].patchValue(previousInventoryEntryId));
      return this.toastHandlerService.showToast('warning',
        `No puede cambiar la entrada mientras el ajuste de costos tenga detalles.`
      );
    }
  }

  async changeConsecutive(consecutive: number) {
    this.branchId = this.formCostAdjustment.get("branchId")?.value;
    this.inventoryId = this.formCostAdjustment.get("inventoryId")?.value;
    if (!this.inventoryId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione un inventario.');
    }
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    if (!consecutive) {
      return this.resetContract();
    }
    try {
      const response = await firstValueFrom(this.costAdjustmentService.getCostAdjustmentByKeys(this.inventoryId,
        this.branchId, consecutive));
      this.costAdjustmentId = response.costAdjustmentId;
      this.costAdjustmentContract = response;
      this.validateForm(this.costAdjustmentContract);
      this.location.replaceState(`/${this.url}/register/${this.costAdjustmentId}`);
    } catch (error) {
      console.error('Error al buscar el ajuste de costos por claves.', error);
    }
  }

  async changeStateCostAdjustment() {
    if (!this.costAdjustmentId) {
      return this.toastHandlerService.showToast('warning', 'Debe crear un ajuste de costos.');
    }
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado del ajuste de costos.
        Comuníquese con el administrador del sistema.`
      );
    }
    if (this.hasAdjustedUnitCostInZero) {
      return this.toastHandlerService.showToast('error', 'No es posible cambiar el estado. Existen artículos con Vr.Aju.Cto.Unit. en cero.');
    }
    try {
      const response = await firstValueFrom(this.costAdjustmentService.setStateCostAdjustment(this.costAdjustmentId));
      this.toastHandlerService.showToast('success', 'El estado del ajuste de costos se modificó exitosamente.');
      this.costAdjustmentContract = response;
      this.validateForm(this.costAdjustmentContract);
    } catch (error) {
      console.error('Error al cambiar el estado del ajuste de costos.', error);
    }
  }

  async changeProvider(currentProviderId: number | null) {
    const previousProviderId = this.costAdjustmentContract.providerId;
    if (previousProviderId != currentProviderId && this.quantityDetails > 0) {
      setTimeout(() => this.formCostAdjustment.controls['providerId'].patchValue(previousProviderId));
      return this.toastHandlerService.showToast('warning',
        `No puede cambiar el proveedor mientras el ajuste de costos tenga detalles.`
      );
    }
    if (!currentProviderId) {
      this.listInventoryEntries = [];
      return;
    }
    this.providerId = currentProviderId;
    await this.getAllLists('inventoryEntries');
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear ajuste de costos.
        Comuníquese con el administrador del sistema.`);
    }
    this.resetContract();
  }

  async createCostAdjustment(model: CostAdjustmentModel) {
    try {
      const response = await firstValueFrom(this.costAdjustmentService.createCostAdjustment(model));
      this.toastHandlerService.showToast('success', `El ajuste de costos fue creado exitosamente.`);
      this.costAdjustmentId = response.costAdjustmentId;
      this.costAdjustmentContract = response;
      this.validateForm(this.costAdjustmentContract);
      this.location.replaceState(`/${this.url}/register/${this.costAdjustmentId}`);
    } catch (error) {
      console.error('Error al crear el ajuste de costos.', error);
    }
  }

  async deleteCostAdjustment() {
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar ajuste de costos.
        Comuníquese con el administrador del sistema.`);
    }
    if (!this.costAdjustmentId) {
      return this.toastHandlerService.showToast('warning', 'Debe crear un ajuste de costos.');
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar el ajuste de costos?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.costAdjustmentService.deleteCostAdjustment(this.costAdjustmentId));
        this.toastHandlerService.showToast('success', 'El ajuste de costos fue eliminado exitosamente.');
        this.createNewRegister();
      } catch (error) {
        console.error('Error al eliminar el ajuste de costos.', error);
      }
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) {
      window.print();
    }
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'inventories' | 'providers' | 'inventoryEntries'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        inventories: async () => {
          this.listInventories = await firstValueFrom(
            this.costAdjustmentService.getAllInventoriesForSelect()
          );
        },
        providers: async () => {
          this.listProviders = await firstValueFrom(
            this.providerService.getAllProvidersForSelect()
          );
        },
        inventoryEntries: async () => {
          if (this.providerId) {
            this.listInventoryEntries = await firstValueFrom(
              this.costAdjustmentService.getAllInventoryEntriesForSelect(this.providerId, this.inventoryId)
            );
          }
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.providers(),
          lists.inventories(),
          lists.inventoryEntries()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formCostAdjustment.get("branchId")?.value;
    this.inventoryId = this.formCostAdjustment.get("inventoryId")?.value;
    if (!this.inventoryId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione un inventario.');
    }
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    await this.handleCostAdjustmentNavigation(buttonClick, this.branchId, this.inventoryId)
  }

  async getCostAdjustmentPrint() {
    try {
      const response = await firstValueFrom(this.costAdjustmentService.getCostAdjustmentByKeysByPrint(this.costAdjustmentId, this.branchId, 0));
      this.costAdjustmentPrintModel = response;
    } catch (error) {
      console.error('Error al obtener el ajuste de costo para impresión', error);
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFirstInventoryByCompanyAuthenticated() {
    try {
      const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyAuthenticatedAsync());
      this.inventoryId = response.inventoryId;
    } catch (error) {
      console.error('Error al obtener inventario principal de la compañia.', error);
    }
  }

  async getFormatByCompanyAndCode() {
    try {
      if (this.formatModel.formatId == 0) {
        const response = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.costAdjustment));
        this.formatModel = response;
      }
    } catch (error) {
      console.error('Error al obtener el formato por compañía.', error);
    }
  }

  async getPermission() {
    this.getUserAuthenticated();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getPermissionPrint(),
      this.getPermissionProfileByUrl()
    ]);
  }

  async getPermissionPrint() {
    try {
      const response = await firstValueFrom(this.costAdjustmentService.getPermissionPrint());
      this.permissionPrint = response;
    } catch (error) {
      console.error('Error al obtener permisos de impresión.', error);
    }
  }

  async getPermissionProfileByUrl() {
    try {
      const response = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.permissionUpdatable = response;
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  getUserAuthenticated() {
    const load = this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
      .subscribe(user => {
        this.companyId = user.companyId;
      });
    this.listObservers.push(load);
  }

  async getCostAdjustmentById() {
    try {
      const response = await firstValueFrom(this.costAdjustmentService.getCostAdjustmentById(this.costAdjustmentId));
      this.branchId = response.branchId;
      this.providerId = response.providerId;
      this.inventoryId = response.inventoryId;
      await this.getAllLists();
      this.costAdjustmentContract = response;
      this.validateForm(this.costAdjustmentContract);
    } catch (error) {
      console.error('Error al obtener el ajuste de costos por id.', error);
    }
  }

  async handleInitialState() {
    if (this.costAdjustmentId) {
      await this.getCostAdjustmentById();
    } else {
      await Promise.all([
        this.getFirstBranchByUserAuthenticated(),
        this.getFirstInventoryByCompanyAuthenticated()
      ]);
      await this.getAllLists();
      this.createNewRegister();
    }
  }

  async handleCostAdjustmentNavigation(buttonClick: any, branchId: number, inventoryId: number) {
    const consecutive = this.formCostAdjustment.get("consecutive")?.value;
    const actionMap: Record<string, () => Promise<CostAdjustmentModel>> = {
      first: () =>
        firstValueFrom(this.costAdjustmentService.getFirstCostAdjustmentByKeys(inventoryId, branchId)),
      previus: () =>
        firstValueFrom(this.costAdjustmentService.getPreviusCostAdjustmentByKeys(inventoryId, branchId, consecutive)),
      next: () =>
        firstValueFrom(this.costAdjustmentService.getNextCostAdjustmentByKeys(inventoryId, branchId, consecutive)),
      last: () =>
        firstValueFrom(this.costAdjustmentService.getLastCostAdjustmentByKeys(inventoryId, branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      return this.resetContract();
    }
    try {
      const costAdjustment = await action();
      this.costAdjustmentId = costAdjustment.costAdjustmentId;
      this.costAdjustmentContract = costAdjustment;
      this.validateForm(this.costAdjustmentContract);
      this.location.replaceState(`/${this.url}/register/${this.costAdjustmentId}`);
    } catch (error) {
      console.error(`Error al buscar el ajuste de costos (${buttonClick.target.id}).`, error);
    }
  }

  async printPage() {
    if (!this.costAdjustmentId) {
      return this.toastHandlerService.showToast(
        'warning',
        'Debe crear un ajuste de costos.'
      );
    }
    if (!this.permissionPrint) {
      return this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para imprimir ajuste de costos.'
      );
    }
    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getCostAdjustmentPrint();
  }

  async send() {
    this.validateFormControls();
    if (!this.formCostAdjustment.valid) {
      return this.showValidationMessages();
    }
    const modelCostAdjustment = this.formCostAdjustment.getRawValue() as CostAdjustmentModel;
    //Hago null, los campos que permiten ser nulos:
    modelCostAdjustment.remission = modelCostAdjustment.remission || null;
    modelCostAdjustment.invoice = modelCostAdjustment.invoice || null;
    modelCostAdjustment.observation = modelCostAdjustment.observation || null;
    if (modelCostAdjustment.remission == null && modelCostAdjustment.invoice == null) {
      return this.toastHandlerService.showToast('warning', `Falta ingresar el numero de la remisión o el numero de la factura.`);
    }
    if (this.costAdjustmentId === 0) {
      await this.createCostAdjustment(modelCostAdjustment);
    } else {
      await this.updateCostAdjustment(modelCostAdjustment);
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      inventoryId: {
        required: 'Debe seleccionar un Inventario.',
        min: 'Debe seleccionar un Inventario válido.'
      },
      branchId: {
        required: 'Debe seleccionar una Sucursal.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      inventoryEntryId: {
        required: 'Debe seleccionar una Entrada de Inventario.',
        min: 'Debe seleccionar una Entrada de Inventario válida.'
      },
      providerId: {
        required: 'Debe seleccionar un Proveedor.',
        min: 'Debe seleccionar un Proveedor válido.'
      },
      dateCostAdjustment: {
        required: 'Debe seleccionar la Fecha del Ajuste de Costos.'
      },
      remission: {
        maxlength: 'El campo Remisión no puede tener más de 15 caracteres.'
      },
      invoice: {
        maxlength: 'El campo Factura no puede tener más de 15 caracteres.'
      },
      observation: {
        maxlength: 'El campo Observación no puede tener más de 250 caracteres.'
      }
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formCostAdjustment.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async resetContract() {
    this.costAdjustmentId = 0;
    this.costAdjustmentContract = new CostAdjustmentModel();
    this.costAdjustmentContract.branchId = this.branchId;
    this.costAdjustmentContract.inventoryId = this.inventoryId;
    this.validateForm(this.costAdjustmentContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  updateFormState() {
    const isNew = this.costAdjustmentId === 0;
    const state = this.costAdjustmentContract.costAdjustmentState;
    const consecutiveControl = this.formCostAdjustment.get('consecutive');
    const stateConfig: Record<number, any> = {
      [CostAdjustmentStateEnums.open]: {
        severity: 'success',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        disableForm: false,
        enableConsecutive: !isNew
      },
      [CostAdjustmentStateEnums.close]: {
        severity: 'danger',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        disableForm: true,
        enableConsecutive: false
      }
    };
    const config = !this.permissionUpdatable ? stateConfig[CostAdjustmentStateEnums.close] : stateConfig[state];
    this.icon = config.icon;
    this.stateText = config.text;
    this.titleState = config.title;
    this.severityState = config.severity;
    this.disabledForm = config.disableForm;
    this.disabledDetail = !config.enableConsecutive;
    if (config.disableForm) {
      setTimeout(() => {
        this.formCostAdjustment.disable();
        this.formControlStateService.setControlState(this.formCostAdjustment,
          ['inventoryId', 'branchId', 'consecutive'], true
        );
      });
    } else {
      setTimeout(() => {
        this.formCostAdjustment.enable();
        config.enableConsecutive ? consecutiveControl?.enable() : consecutiveControl?.disable();
      });
    }
  }

  async updateCostAdjustment(model: CostAdjustmentModel) {
    this.costAdjustmentContract.dateCostAdjustment = model.dateCostAdjustment;
    this.costAdjustmentContract.inventoryEntryId = model.inventoryEntryId;
    this.costAdjustmentContract.providerId = model.providerId;
    this.costAdjustmentContract.remission = model.remission;
    this.costAdjustmentContract.invoice = model.invoice;
    this.costAdjustmentContract.observation = model.observation;
    try {
      const response = await firstValueFrom(this.costAdjustmentService.updateCostAdjustment(this.costAdjustmentContract));
      this.toastHandlerService.showToast('success', `El ajuste de costos fue modificado exitosamente.`);
      this.costAdjustmentContract = response;
      this.validateForm(this.costAdjustmentContract);
    } catch (error) {
      console.error('Error al modificar el ajuste de costos.', error);
    }
  }

  async validateForm(costAdjustment: CostAdjustmentModel) {
    this.formCostAdjustment = this.formBuilder.group({
      inventoryId: [costAdjustment.inventoryId, [Validators.required, Validators.min(1)]],
      branchId: [costAdjustment.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [costAdjustment.consecutive],
      inventoryEntryId: [costAdjustment.inventoryEntryId, [Validators.required, Validators.min(1)]],
      providerId: [costAdjustment.providerId, [Validators.required, Validators.min(1)]],
      dateCostAdjustment: [costAdjustment.dateCostAdjustment ?
        this.dateConverterService.convertUtcToLocalDate(costAdjustment.dateCostAdjustment) : null, [Validators.required]],
      remission: [costAdjustment.remission, [Validators.maxLength(15)]],
      invoice: [costAdjustment.invoice, [Validators.maxLength(15)]],
      observation: [costAdjustment.observation, [Validators.maxLength(250)]],
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formCostAdjustment.controls).forEach((key) => {
      const control = this.formCostAdjustment.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
